import React from 'react';
import { Input } from '@thd-olt-component-react/input';
import Field from '../../common/Field/Field';

export function JobPostingInput({
  required,
  value,
  maxLength,
  dirty,
  description,
  label,
  jpKey,
  errorText,
  updateJobPostingAttr,
  onFocus,
  validate,
  didError,
  onBlur,
  type
}) {

  return (
    <Field
      label={label}
      dirty={dirty}
      description={description}
      showError={didError}
      errorText={errorText}
      required={required}
    >
      <div data-testid={`job-posting-editor-${jpKey}`}>
        <Input
          required={required}
          {...type === 'textarea' && { className: 'ptp-job-posting__text-area' }}
          type={type}
          validateOnBlur
          value={value}
          {...maxLength && { maxLength }}
          onChange={(inputValue) => {
            updateJobPostingAttr(inputValue);
          }}
          onFocus={onFocus}
          onBlur={onBlur}
          validation={validate}
          errorText={errorText}
          name="companyName"
        />
      </div>
    </Field>
  );

}
